/**
 * Snap-strefy: przyciąganie drag do miski / stołu / talerza (PLAN-V2 §3.1).
 * Czysta logika — bez Phaser.
 */

import type { SnapZone } from './types.js';

export type SnapResult = {
  zone: SnapZone;
  distance: number;
};

/**
 * Najbliższa strefa w promieniu, opcjonalnie filtrowana listą dozwolonych id
 * (ObjectDef.snapTargets).
 */
export function findSnapTarget(
  x: number,
  y: number,
  zones: readonly SnapZone[],
  allowedIds?: readonly string[] | null,
): SnapResult | null {
  let best: SnapResult | null = null;
  for (const zone of zones) {
    if (allowedIds && allowedIds.length > 0 && !allowedIds.includes(zone.id)) {
      continue;
    }
    const dx = x - zone.x;
    const dy = y - zone.y;
    const distance = Math.hypot(dx, dy);
    if (distance > zone.radius) continue;
    if (!best || distance < best.distance) {
      best = { zone, distance };
    }
  }
  return best;
}

/** Pozycja po snap (środek strefy). */
export function snapPosition(zone: SnapZone): { x: number; y: number } {
  return { x: zone.x, y: zone.y };
}

/**
 * Czy punkt (x,y) leży w strefie o danym id.
 */
export function isInsideZone(
  x: number,
  y: number,
  zone: SnapZone,
): boolean {
  return Math.hypot(x - zone.x, y - zone.y) <= zone.radius;
}
